/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { AddFittingPanelFrameComponent } from './add-fitting-panel-frame.component';
export { AddFittingPanelFrameModule } from './add-fitting-panel-frame.module';